module.exports = __webpack_public_path__ + "img/thingstodo.874337fc.svg";